/*
 * @Author: renxin
 * @Date: 2021-10-27 10:43:18
 * @LastEditors: renxin
 * @LastEditTime: 2024-03-12 20:06:11
 * @Description: 
 */
export default [
  // 购物车页
  {
    path: '/shoppingcart',
    name: 'shoppingCart',
    meta: {
      type: 'page',
      title: '购物车',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: 'shoppingcart' */ 'views/shopcart/list')
  },
  {
    path: '/shoppingcart/gather',
    name: 'shoppingcartGather',
    meta: {
      type: 'page',
      title: '凑单优惠'
    },
    component: () => import(/* webpackChunkName: 'gather' */ 'views/shopcart/gather')
  }
]
